import { DeploymentType, IConfig, SourceApp } from "../../../Config";
import { IProductSalesInfoMap } from "../../../newSearch/models/IProductSalesInfo";
import { IProductDescription } from "../../../ts/models/product/IProductDescription";
import { ILpSeriesInfo } from "../../../ts/providers/IProductProvider";
import { INewsAndRecentlyRead } from "../../models/INewsAndRecentlyRead";
import { IProductForum } from "../../models/IProductForum";
import { IManningActivitySummary } from "../../models/ManningActivitySummary";
import { IOwnedProduct } from "../../models/OwnedProduct";
import { IManningOnlineProvider } from "./IManningOnlineProvider";

export class ManningOnlineProvider {
    public config: IConfig;
    public deploymentType: DeploymentType;
    public sourceApp: SourceApp;
    private provider: IManningOnlineProvider;
    
    
    constructor(provider: IManningOnlineProvider){
        this.provider = provider;
        this.config = this.provider.config;
        this.deploymentType = this.provider.deploymentType;
        this.sourceApp = this.provider.sourceApp;
    }

    public getNewsAndRecentlyRead(): Promise<INewsAndRecentlyRead> {
        return this.provider.getNewsAndRecentlyRead();
    }

    public getRecommendedReading(): Promise<IProductDescription[]> {
        return this.provider.getRecommendedReading();
    }

    public getManningActivitySummary(): Promise<IManningActivitySummary> {
        return this.provider.getManningActivitySummary();
    }

    public getAllProducts(): Promise<IProductDescription[]> {
        return this.provider.getAllProducts();
    }

    public getProductDescription(productId: number): Promise<IProductDescription> {
        return this.provider.getProductDescription(productId);
    }

    public getOwnedProducts(): Promise<IOwnedProduct[]>{
        return this.provider.getOwnedProducts();
    }

    private productSalesInfoMapPromise: Promise<IProductSalesInfoMap>;
    public getProductInfoSalesMap(): Promise<IProductSalesInfoMap> {
        if(this.productSalesInfoMapPromise) { return this.productSalesInfoMapPromise; }

        return this.productSalesInfoMapPromise = new Promise<IProductSalesInfoMap> ((resolve, reject) => {
            this.provider.getProductSalesInfo().then(data => {
                const productSalesInfoMap: IProductSalesInfoMap = {};
                for(const item of data){
                    productSalesInfoMap[item.productId] = item.value;
                }
                resolve(productSalesInfoMap);
            }).catch(e => {
                console.log(e);
                resolve({});
            });
        });
    }

    private productPercentageFinishedMap: {[productId: number]: number} = {};
    public getProductPercentageFinished(productId: number): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.getProductsPercentageFinished([productId]).then(map => {
                resolve(map[productId]);
            }).catch(e => reject(e))
        });
    }

    public getProductsPercentageFinished(productIds: number[]): Promise<{[productId: number]: number}> {
        const resultMap: {[productId: number]: number} = {};
        const notFoundProductIds = [];
        for(const productId of productIds){
            if(this.productPercentageFinishedMap[productId]){
                resultMap[productId] = this.productPercentageFinishedMap[productId];
            }
            else {
                notFoundProductIds.push(productId);
            }
        }

        if(notFoundProductIds.length == 0){
            return Promise.resolve(resultMap);
        }

        return new Promise<{[productId: number]: number}>((resolve, reject) => {
            this.provider.getProductsPercentageFinished(notFoundProductIds)
                         .then(result => {
                             for(const id in result){
                                 resultMap[id] = result[id];
                             }

                             resolve(resultMap);
                         })
                         .catch(e => resolve(resultMap))
        });
    }

    public getProductForum(productId: number): Promise<IProductForum> {
        return new Promise<IProductForum>((resolve, reject) => {
            this.provider.getProductForum(productId).then(productForum => {
                productForum.comments = productForum.comments.filter(it => !it.isEditingSuggestion);
                resolve(productForum);
            }).catch(e => reject(e));
        });
    }

    private lpSeriesInfoPromise: Promise<ILpSeriesInfo[]>;
    public getLpSeriesInfo(): Promise<ILpSeriesInfo[]> {
        if(this.lpSeriesInfoPromise) { return this.lpSeriesInfoPromise; }

        return this.lpSeriesInfoPromise = this.provider.getLpSeriesInfo();
    }
}